import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logOut } from "../../features/auth/authSlice";

import { baseUrl } from "../../utils/commonMethods";

const baseQuery = fetchBaseQuery({
  baseUrl,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    headers.set("Accept", "*/*");
    return headers;
  },
});

let refreshTokenPromise = null;

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    if (!refreshTokenPromise) {
      refreshTokenPromise = (async () => {
        try {
          const refreshResult = await baseQuery(
            { url: "/auth/tokens:refresh", method: "POST" },
            api,
            extraOptions
          );

          if (refreshResult?.data?.user) {
            api.dispatch(
              setCredentials({
                isAuthenticatedUser: true,
                user: refreshResult.data.user,
              })
            );
            return true;
          } else {
            api.dispatch(logOut());
            return false;
          }
        } catch (error) {
          console.error("Refresh failed:", error);
          api.dispatch(logOut());
          return false;
        } finally {
          refreshTokenPromise = null;
        }
      })();
    }

    const refreshSuccess = await refreshTokenPromise;

    if (refreshSuccess) {
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Tasks",
    "TaskDetails",
    "Incidents",
    "IncidentDetails",
    "IncidentTaskCreationTriggers",
    "Triggers",
    "IncidentTypes",
    "IncidentSubTypes",
    "LibraryTasks",
    "IncidentCreationDetails",
    "IncidentStatus",
    "TaskStatus",
    "TaskInsights",
    "IncidentInsights",
    "IncidentGroups",
    "IncidentForms",
    "LinkedIncidents",
    "RelatedIncidents",
    "Users",
    "Roles",
    "IncidentClosureForms",
    "CostCenters",
    "Releases",
  ],
  endpoints: (builder) => ({}),
});
